import { Component, OnInit } from '@angular/core';
import { LocationService } from "../../services/location.service";
import { UserService } from "../../services/user.service";
import { Condition } from '../../models/condition';
declare const $: any;

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.css']
})
export class CurrencyComponent implements OnInit{

public loadingCurrencies = false;
public currencies: any[] = [];
public condition: Condition = new Condition();
public token = "";

constructor(private _locationService: LocationService, private _userService: UserService,){
 this.token = this._userService.getToken();
  this.getCurrencies();
}

    ngOnInit(){
          $("#ModalCurrency").on('hidden.bs.modal', () => {
            this.condition = new Condition();
          });
    }

    getCurrencies() {
    this.loadingCurrencies = true;
    this.currencies = [];
    this._locationService.getCurrencies(this.token).subscribe(
      (response) => {
      this.currencies = response.data;
      //console.log(this.currencies);
      this.loadingCurrencies = false;
    },error =>{
      console.log('error ',error);
    });
  }


  editCurrencies(item){
     this.loadingCurrencies = true;
    this._locationService.editCurrencie(this.token,item.name,item.id).subscribe(
      r =>{
        //console.log('ressss ',r);
         this.loadingCurrencies = false;
         this.getCurrencies();
         this.hide();
      },error=>{
        console.log('error ',error);
         this.loadingCurrencies = false;
         this.getCurrencies();
         this.hide();
      }
    );
  }

  deleteCurren(item){
     this._locationService.deleteCurrency(this.token,item.id).subscribe(
      r =>{
        //console.log('ressss ',r);
         this.loadingCurrencies = false;
         this.getCurrencies();
         this.hide();
      },error=>{
        console.log('error ',error);
         this.loadingCurrencies = false;
         this.getCurrencies();
         this.hide();
      }
    );
  }

  detail(item){
     this.condition = new Condition(item.id, item.name);
    $("#ModalCurrency").appendTo("body").modal("show");

  }

   create() {
    this.condition = new Condition();
    $("#ModalCurrency").appendTo("body").modal("show");
  }

  hide(){
     $("#ModalCurrency").modal("hide");
  }

}
